export default __webpack_public_path__ + "static/media/Arquivo XLS.baa3814a.svg";